"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SzModal = void 0;

var react_1 = __importDefault(require("react"));

var react_bootstrap_1 = require("react-bootstrap");

var __1 = require("../../");

var classnames_1 = __importDefault(require("classnames"));

require("./SzModal.scss");

exports.SzModal = function (props) {
  var _a;

  var handleClose = props.handleClose,
      show = props.show,
      title = props.title,
      children = props.children,
      className = props.className,
      _b = props.size,
      size = _b === void 0 ? 'lg' : _b,
      _c = props.backdrop,
      backdrop = _c === void 0 ? true : _c,
      _d = props.hideCloseBtn,
      hideCloseBtn = _d === void 0 ? false : _d,
      _e = props.centered,
      centered = _e === void 0 ? false : _e,
      border = props.border,
      fullscreen = props.fullscreen;
  var modalClasses = classnames_1.default('sz-modal text-secondary', (_a = {
    'border-smooth': border && 'smooth' === border
  }, _a['fullscreen-' + fullscreen] = fullscreen && fullscreen, _a), className);
  return react_1.default.createElement(react_bootstrap_1.Modal, {
    className: modalClasses,
    show: show,
    onHide: handleClose,
    size: size,
    backdrop: backdrop,
    centered: centered
  }, react_1.default.createElement(react_bootstrap_1.Modal.Header, {
    className: "sz-modal_header border-0 px-3 px-md-5 pb-0"
  }, react_1.default.createElement(react_bootstrap_1.Modal.Title, {
    as: __1.SzTypographie,
    variant: "h2",
    weight: "bold",
    className: "mb-4 w-100"
  }, title), (hideCloseBtn || backdrop !== 'static') && react_1.default.createElement(__1.SzButton, {
    variant: "tertiary",
    icon: "close",
    className: "sz-modal_close position-absolute",
    onClick: handleClose
  })), react_1.default.createElement(react_bootstrap_1.Modal.Body, {
    className: "sz-modal_body px-3 px-md-5 pb-4 pt-0"
  }, children));
};

exports.default = exports.SzModal;